import { UserAvatar } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { SKELETON_CLASSNAME } from '../../base/constants';
import './UserRank.scss';

export interface IUserRankProps {
  active: boolean;
  loading: boolean;
  name: string;
  picture?: string;
  ranking?: number | string;
  score?: number | string;
}

export default function UserRank({ active, loading, name, picture, ranking, score }: Readonly<IUserRankProps>) {
  const { t } = useTranslation();

  const baseCardClass = 'highscores-rank';
  if (!ranking && !loading) {
    return <div className={`${baseCardClass} empty`} />;
  }
  const activeClass = active ? ' active' : '';
  const loadingClass = loading ? ` ${SKELETON_CLASSNAME}` : '';
  const containerClass = `${baseCardClass}${activeClass}${loadingClass}`;
  let topLabel: React.ReactNode = <div className={SKELETON_CLASSNAME}>...</div>;
  if (!loading) {
    // score === 0 must be shown especially when ranking is defined
    if (!ranking || score === undefined) {
      topLabel = <span>&nbsp;</span>;
    } else {
      const topLabelVars = {
        ranking: `${ranking}`,
        score: `${score}`,
      };
      topLabel = t('Highscore.TopLabel', topLabelVars);
    }
  }
  const bottomLabel = loading ? <div className={SKELETON_CLASSNAME}>...</div> : <small title={name}>{name}</small>;
  return (
    <div className={containerClass}>
      <div className="rank-top">{topLabel}</div>
      <div className="rank-middle">
        <UserAvatar picture={picture} />
      </div>
      <div className="rank-bottom">{bottomLabel}</div>
    </div>
  );
}
